import React, { Component, useEffect, useState } from 'react';
import * as d3 from "d3";
import Gene from './input/gene'
import Variant from './input/variant'

function Input (props) {

    const emptySpace = props.emptySpace,
        setLocus = props.setLocus,
        setSlot = props.setSlot;

    useEffect (()=>{
    })

    return (
        <div id="input" className="section">
            <div className="section_header">
                <h1>Input search</h1>
            </div>
            <div className="section_content">
                <div>
                    <h3>Variant</h3>
                    <p style={{marginBottom: 9}}>Type the variant whose surroundings you want<br/>to inspect. Use the following annotation.<br/>Chr : Pos : Ref : Alt</p>
                    <Variant 
                        setLocus={setLocus}
                        setSlot={setSlot}
                        emptySpace={emptySpace}
                    />
                </div>
                <div>
                    <h3>Gene</h3>
                    <p>Type the gene code whose<br/>corresponding loci you want to analyze.<br/>Use the Havana annotation.</p>
                    <Gene 
                        setLocus={setLocus}
                        setSlot={setSlot}
                        emptySpace={emptySpace}
                    />
                </div>
            </div>
        </div>
    )
}
export default Input;